module.exports = __webpack_public_path__ + "dashboard/img/down.46f80c82ed7451bfd9e187638b6fb533.svg";